import 'babel-polyfill'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App'
import Button from '../../components/base/Button'
import Modal from '../../components/modal'
import Tooltip from '../../components/toolTip'
import { cookie } from '../../utils/cookie'
import { initSentry } from '../../utils/Sentry'
import { getConstants } from './baseData'
import '../../styles/index.scss'

initSentry()
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Modal)
Vue.prototype.PageInfo = PageInfo
Vue.prototype.getConstants = getConstants
Vue.prototype.switchLang = lang => {
	const current = cookie.get('page_locale')
	if (current !== lang) {
		cookie.set('page_locale', lang)
		location.reload()
	}
}

void new Vue({
	el: '#app',
	render: h => h(App),
})
